import {
  ProductSliderLoader,
  HomeBannerLoader,
  SectionLoader,
} from "@/components/Loading";
import { Skeleton } from "@/components/ui/skeleton";

export default function HomePageLoader() {
  return (
    <>
      <main className="flex min-h-screen flex-col overflow-x-hidden">
        <div className="w-full">
          <div className="max-w-[1920px]  mx-auto">
            <HomeBannerLoader />
          </div>
        </div>

        <div className="  pt-[0px] pb-[0px] mt-[60px] lg:mt-[70px] md:mt-[60px]">
          <ProductSliderLoader />
        </div>

        <div className="mb-[70px]">
          <div className="max-w-[1440px] mt-[70px] mb-[62px]  mx-auto">
            <Skeleton className={"w-20 h-6"} />
          </div>

          <SectionLoader />
        </div>

        <div className="p-6 pt-0 pb-0 lg:mb-[140px] mb-[70px]">
          <ProductSliderLoader />
        </div>

        <div className="lg:mb-[70px]">
          <div className="max-w-[1440px] p-6 pt-[0] pb-[0] mt-[70px] mb-[62px] text-center mx-auto">
            <Skeleton className={"w-20 h-6"} />

            <ul className="flex flex-wrap gap-2 lg:justify-between justify-center mt-[32px]">
              {Array.from({ length: 10 }).map((_, index) => {
                return (
                  <li key={index} className=" rounded-full ">
                    <Skeleton className={"w-5 h-4"} />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <div className="mb-[60px] lg:mb-[140px] md:mb-[70px]">
          <div className="w-full">
            <div className="md:flex mx-auto">
              <div className="flex flex-wrap w-full">
                <SectionLoader />
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 pt-0 pb-0 lg:mb-[140px] mb-[70px]">
          <ProductSliderLoader />
        </div>

        <div className="w-full">
          <SectionLoader />
        </div>
      </main>
    </>
  );
}
